import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import {
    getProblemReportsRequest,
    getProblemReportsSuccess,
    getProblemReportsError,
} from '../../slices/support/ProblemReportsSlice';

export const GetProblemReportsAPI = (page = 1, limit = 10, status = '') => async (dispatch) => {
    const params = new URLSearchParams({ page, limit });
    if (status) params.append('status', status);

    try {
        dispatch(getProblemReportsRequest());
        axiosInstance({
            method: 'GET',
            url: `${endpoints.problemReports}?${params.toString()}`,
            headers: { 'Content-Type': 'application/json' },
        })
            .then((resp) => dispatch(getProblemReportsSuccess(resp?.data)))
            .catch((error) => {
                dispatch(getProblemReportsError({
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                }));
            });
    } catch (error) { }
};

